import templateGet from './get/template.html';
import controllerGet from './get';
import {
  userLicensesLicenseNavState,
  userLicensesLicenseAttachmentsState,
  userLicensesLicenseCarryOverState,
  userLicensesLicenseEditState,
  userLicensesLicenseExtensionsState
} from './license';

const usersLicensesState = {
  url: '/licenses?source?tour',
  stateName: 'My License',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: templateGet,
      controller: controllerGet,
      controllerAs: 'usersLicenseCtrl'
    }
  }
};

export {
  usersLicensesState,
  userLicensesLicenseCarryOverState,
  userLicensesLicenseNavState,
  userLicensesLicenseEditState,
  userLicensesLicenseAttachmentsState,
  userLicensesLicenseExtensionsState
};



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/licenses/index.js